// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/notebook/v1/kernel_service.proto (package chalk.notebook.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { NotebookRunScope } from "./document_pb";
import { file_chalk_notebook_v1_document } from "./document_pb";
import type { NotebookRunEvent } from "./runtime_pb";
import { file_chalk_notebook_v1_runtime } from "./runtime_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/notebook/v1/kernel_service.proto.
 */
export const file_chalk_notebook_v1_kernel_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_notebook_v1_document, file_chalk_notebook_v1_runtime, file_google_protobuf_timestamp]);

/**
 * One `{{ expression }}` site extracted from a markdown/text cell by the
 * orchestrating server. The kernel eval()s `source` against the session
 * namespace — eval binds no names, so template evaluation never perturbs the
 * user namespace or the variable snapshot — and stamps every resulting output
 * chunk with `key` so the renderer can match chunks back to template sites.
 *
 * @generated from message chalk.notebook.v1.NotebookTemplateExpression
 */
export type NotebookTemplateExpression = Message<"chalk.notebook.v1.NotebookTemplateExpression"> & {
  /**
   * Unique within one RunPythonCellSpec. Chunks produced by this expression
   * (including error chunks) carry it in NotebookOutputChunk.expression_key.
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * Python expression text (no statements; evaluated with eval()).
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * Optional f-string-style format spec, applied kernel-side as
   * format(value, format_spec) when the result renders as text. Ignored for
   * rich results (dataframes, charts, display-protocol objects).
   *
   * @generated from field: string format_spec = 3;
   */
  formatSpec: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookTemplateExpression.
 * Use `create(NotebookTemplateExpressionSchema)` to create a new message.
 */
export const NotebookTemplateExpressionSchema: GenMessage<NotebookTemplateExpression> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 0);

/**
 * The execution payload of one RunPythonCell exchange. The RPC request
 * message is RunPythonCellRequest, whose oneof also carries blob-upload
 * control frames on the same bidi stream.
 *
 * @generated from message chalk.notebook.v1.RunPythonCellSpec
 */
export type RunPythonCellSpec = Message<"chalk.notebook.v1.RunPythonCellSpec"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string cell_run_id = 2;
   */
  cellRunId: string;

  /**
   * @generated from field: string cell_id = 3;
   */
  cellId: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: int32 timeout_seconds = 5;
   */
  timeoutSeconds: number;

  /**
   * @generated from field: map<string, string> secrets = 6;
   */
  secrets: { [key: string]: string };

  /**
   * Stable identifier for the interpreter session this cell expects to run
   * in (one session per notebook runtime). The kernel rejects the request if
   * it is serving a different session.
   *
   * @generated from field: string session_id = 8;
   */
  sessionId: string;

  /**
   * Kernel epoch the caller last observed. The epoch changes every time the
   * kernel process (and therefore all interpreter state) is restarted. When
   * set and stale, the kernel terminates the execution with
   * PYTHON_EXECUTION_OUTCOME_KERNEL_RESTARTED instead of silently running
   * against empty globals. Empty means "any epoch".
   *
   * @generated from field: string expected_kernel_epoch = 9;
   */
  expectedKernelEpoch: string;

  /**
   * Human-readable cell name used as the synthetic <filename> for compiled
   * cell code so tracebacks read "<cell name>, line N" instead of a hash.
   *
   * @generated from field: string cell_display_name = 10;
   */
  cellDisplayName: string;

  /**
   * Number of lines prepended to `source` by the caller (dataframe/secret
   * preludes). The kernel subtracts this from traceback line numbers that
   * fall inside user code so reported lines match what the user wrote.
   *
   * @generated from field: int32 prelude_line_count = 11;
   */
  preludeLineCount: number;

  /**
   * When set, the kernel does not execute `source` at all. Instead it
   * captures the named global from the interpreter namespace as a full
   * dataframe artifact (parquet) through the blob-upload handshake, running
   * only silent helper code: no execution count is consumed, no In/Out
   * history is written, and no variable snapshot is emitted. Used to export
   * kernel dataframes referenced by SQL cells.
   *
   * @generated from field: string export_variable_name = 12;
   */
  exportVariableName: string;

  /**
   * Template expressions to evaluate after `source` runs (markdown/text cells
   * send these with an empty `source`, so nothing is executed first). Each is
   * eval()ed independently: one failing expression emits a keyed ERROR chunk
   * and evaluation continues with the next. Like export_variable_name runs,
   * expression-only executions consume no execution count and write no In/Out
   * history, but they DO require a live session namespace.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookTemplateExpression template_expressions = 13;
   */
  templateExpressions: NotebookTemplateExpression[];
};

/**
 * Describes the message chalk.notebook.v1.RunPythonCellSpec.
 * Use `create(RunPythonCellSpecSchema)` to create a new message.
 */
export const RunPythonCellSpecSchema: GenMessage<RunPythonCellSpec> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 1);

/**
 * Terminal message for one RunPythonCell exchange. Exactly one is sent as the
 * final event-bearing message of every execution; stream EOF without it must
 * be treated as an error by the client.
 *
 * @generated from message chalk.notebook.v1.PythonExecutionTerminated
 */
export type PythonExecutionTerminated = Message<"chalk.notebook.v1.PythonExecutionTerminated"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string cell_run_id = 2;
   */
  cellRunId: string;

  /**
   * @generated from field: chalk.notebook.v1.PythonExecutionOutcome outcome = 3;
   */
  outcome: PythonExecutionOutcome;

  /**
   * Optional operator-facing detail (timeout duration, kernel exit status).
   *
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * Epoch of the kernel that (attempted to) run this cell.
   *
   * @generated from field: string kernel_epoch = 5;
   */
  kernelEpoch: string;

  /**
   * @generated from field: int64 execution_count = 6;
   */
  executionCount: bigint;
};

/**
 * Describes the message chalk.notebook.v1.PythonExecutionTerminated.
 * Use `create(PythonExecutionTerminatedSchema)` to create a new message.
 */
export const PythonExecutionTerminatedSchema: GenMessage<PythonExecutionTerminated> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 2);

/**
 * @generated from message chalk.notebook.v1.StartPythonCellRequest
 */
export type StartPythonCellRequest = Message<"chalk.notebook.v1.StartPythonCellRequest"> & {
  /**
   * @generated from field: chalk.notebook.v1.RunPythonCellSpec spec = 1;
   */
  spec?: RunPythonCellSpec;

  /**
   * Stable idempotency key for this execution. This is usually the cell run ID,
   * but child operations such as variable exports use their own execution ID
   * while retaining the parent cell run ID in the spec.
   *
   * @generated from field: string execution_id = 2;
   */
  executionId: string;
};

/**
 * Describes the message chalk.notebook.v1.StartPythonCellRequest.
 * Use `create(StartPythonCellRequestSchema)` to create a new message.
 */
export const StartPythonCellRequestSchema: GenMessage<StartPythonCellRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 3);

/**
 * @generated from message chalk.notebook.v1.StartPythonCellResponse
 */
export type StartPythonCellResponse = Message<"chalk.notebook.v1.StartPythonCellResponse"> & {
  /**
   * Stable execution handle. This matches StartPythonCellRequest.execution_id.
   *
   * @generated from field: string execution_id = 1;
   */
  executionId: string;
};

/**
 * Describes the message chalk.notebook.v1.StartPythonCellResponse.
 * Use `create(StartPythonCellResponseSchema)` to create a new message.
 */
export const StartPythonCellResponseSchema: GenMessage<StartPythonCellResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 4);

/**
 * @generated from message chalk.notebook.v1.PythonCellExecutionEvent
 */
export type PythonCellExecutionEvent = Message<"chalk.notebook.v1.PythonCellExecutionEvent"> & {
  /**
   * Monotonically increasing within one execution, starting at 1.
   *
   * @generated from field: int64 sequence = 1;
   */
  sequence: bigint;

  /**
   * @generated from field: chalk.notebook.v1.RunPythonCellResponse response = 2;
   */
  response?: RunPythonCellResponse;
};

/**
 * Describes the message chalk.notebook.v1.PythonCellExecutionEvent.
 * Use `create(PythonCellExecutionEventSchema)` to create a new message.
 */
export const PythonCellExecutionEventSchema: GenMessage<PythonCellExecutionEvent> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 5);

/**
 * @generated from message chalk.notebook.v1.StreamPythonCellEventsResponse
 */
export type StreamPythonCellEventsResponse = Message<"chalk.notebook.v1.StreamPythonCellEventsResponse"> & {
  /**
   * Events that were ready when the stream was serviced. Live streams usually
   * contain one event; replay can batch retained events without delaying delivery.
   *
   * @generated from field: repeated chalk.notebook.v1.PythonCellExecutionEvent events = 1;
   */
  events: PythonCellExecutionEvent[];
};

/**
 * Describes the message chalk.notebook.v1.StreamPythonCellEventsResponse.
 * Use `create(StreamPythonCellEventsResponseSchema)` to create a new message.
 */
export const StreamPythonCellEventsResponseSchema: GenMessage<StreamPythonCellEventsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 6);

/**
 * @generated from message chalk.notebook.v1.StreamPythonCellEventsRequest
 */
export type StreamPythonCellEventsRequest = Message<"chalk.notebook.v1.StreamPythonCellEventsRequest"> & {
  /**
   * @generated from field: string execution_id = 1;
   */
  executionId: string;

  /**
   * Replay events whose sequence is greater than this cursor, then continue
   * streaming new events. Zero starts at the beginning of the retained log.
   *
   * @generated from field: int64 after_sequence = 2;
   */
  afterSequence: bigint;
};

/**
 * Describes the message chalk.notebook.v1.StreamPythonCellEventsRequest.
 * Use `create(StreamPythonCellEventsRequestSchema)` to create a new message.
 */
export const StreamPythonCellEventsRequestSchema: GenMessage<StreamPythonCellEventsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 7);

/**
 * @generated from message chalk.notebook.v1.PythonCellRequestFailure
 */
export type PythonCellRequestFailure = Message<"chalk.notebook.v1.PythonCellRequestFailure"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message chalk.notebook.v1.PythonCellRequestFailure.
 * Use `create(PythonCellRequestFailureSchema)` to create a new message.
 */
export const PythonCellRequestFailureSchema: GenMessage<PythonCellRequestFailure> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 8);

/**
 * @generated from message chalk.notebook.v1.RespondToPythonCellRequest
 */
export type RespondToPythonCellRequest = Message<"chalk.notebook.v1.RespondToPythonCellRequest"> & {
  /**
   * @generated from field: string execution_id = 1;
   */
  executionId: string;

  /**
   * @generated from field: string request_id = 2;
   */
  requestId: string;

  /**
   * @generated from oneof chalk.notebook.v1.RespondToPythonCellRequest.response
   */
  response: {
    /**
     * @generated from field: chalk.notebook.v1.NotebookBlobUploadTarget blob_upload_target = 3;
     */
    value: NotebookBlobUploadTarget;
    case: "blobUploadTarget";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.PythonCellRequestFailure failure = 4;
     */
    value: PythonCellRequestFailure;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.notebook.v1.RespondToPythonCellRequest.
 * Use `create(RespondToPythonCellRequestSchema)` to create a new message.
 */
export const RespondToPythonCellRequestSchema: GenMessage<RespondToPythonCellRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 9);

/**
 * @generated from message chalk.notebook.v1.RespondToPythonCellResponse
 */
export type RespondToPythonCellResponse = Message<"chalk.notebook.v1.RespondToPythonCellResponse"> & {
};

/**
 * Describes the message chalk.notebook.v1.RespondToPythonCellResponse.
 * Use `create(RespondToPythonCellResponseSchema)` to create a new message.
 */
export const RespondToPythonCellResponseSchema: GenMessage<RespondToPythonCellResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 10);

/**
 * @generated from message chalk.notebook.v1.InterruptPythonExecutionRequest
 */
export type InterruptPythonExecutionRequest = Message<"chalk.notebook.v1.InterruptPythonExecutionRequest"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string cell_run_id = 2;
   */
  cellRunId: string;

  /**
   * @generated from field: string session_id = 3;
   */
  sessionId: string;
};

/**
 * Describes the message chalk.notebook.v1.InterruptPythonExecutionRequest.
 * Use `create(InterruptPythonExecutionRequestSchema)` to create a new message.
 */
export const InterruptPythonExecutionRequestSchema: GenMessage<InterruptPythonExecutionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 11);

/**
 * @generated from message chalk.notebook.v1.InterruptPythonExecutionResponse
 */
export type InterruptPythonExecutionResponse = Message<"chalk.notebook.v1.InterruptPythonExecutionResponse"> & {
  /**
   * @generated from field: chalk.notebook.v1.PythonInterruptOutcome outcome = 1;
   */
  outcome: PythonInterruptOutcome;
};

/**
 * Describes the message chalk.notebook.v1.InterruptPythonExecutionResponse.
 * Use `create(InterruptPythonExecutionResponseSchema)` to create a new message.
 */
export const InterruptPythonExecutionResponseSchema: GenMessage<InterruptPythonExecutionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 12);

/**
 * @generated from message chalk.notebook.v1.DescribeKernelSessionRequest
 */
export type DescribeKernelSessionRequest = Message<"chalk.notebook.v1.DescribeKernelSessionRequest"> & {
};

/**
 * Describes the message chalk.notebook.v1.DescribeKernelSessionRequest.
 * Use `create(DescribeKernelSessionRequestSchema)` to create a new message.
 */
export const DescribeKernelSessionRequestSchema: GenMessage<DescribeKernelSessionRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 13);

/**
 * @generated from message chalk.notebook.v1.DescribeKernelSessionResponse
 */
export type DescribeKernelSessionResponse = Message<"chalk.notebook.v1.DescribeKernelSessionResponse"> & {
  /**
   * @generated from field: string session_id = 1;
   */
  sessionId: string;

  /**
   * @generated from field: string kernel_epoch = 2;
   */
  kernelEpoch: string;

  /**
   * @generated from field: bool kernel_alive = 3;
   */
  kernelAlive: boolean;

  /**
   * Set when a cell is currently executing.
   *
   * @generated from field: string executing_run_id = 4;
   */
  executingRunId: string;

  /**
   * @generated from field: string executing_cell_run_id = 5;
   */
  executingCellRunId: string;

  /**
   * Current memory charged to the kernel container's cgroup. Zero when the
   * runtime is not inside a memory-accounted cgroup.
   *
   * @generated from field: uint64 memory_usage_bytes = 6;
   */
  memoryUsageBytes: bigint;

  /**
   * Memory ceiling for the kernel container's cgroup. Zero when unlimited or
   * unavailable (for example, a local development kernel on macOS).
   *
   * @generated from field: uint64 memory_limit_bytes = 7;
   */
  memoryLimitBytes: bigint;
};

/**
 * Describes the message chalk.notebook.v1.DescribeKernelSessionResponse.
 * Use `create(DescribeKernelSessionResponseSchema)` to create a new message.
 */
export const DescribeKernelSessionResponseSchema: GenMessage<DescribeKernelSessionResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 14);

/**
 * @generated from message chalk.notebook.v1.InstalledPackage
 */
export type InstalledPackage = Message<"chalk.notebook.v1.InstalledPackage"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string version = 2;
   */
  version: string;
};

/**
 * Describes the message chalk.notebook.v1.InstalledPackage.
 * Use `create(InstalledPackageSchema)` to create a new message.
 */
export const InstalledPackageSchema: GenMessage<InstalledPackage> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 15);

/**
 * What code a notebook kernel is actually running.
 *
 * Exists because a package version does not answer that question for the piece
 * that matters most. libchalk ships as a compiled extension inside the chalkdf
 * wheel, and chalkdf is installed from public PyPI whose releases are cut by
 * hand — so a kernel can sit weeks behind the repo with nothing in the product
 * saying so, and "is this feature deployed here?" becomes unanswerable without
 * shell access to the kernel. Every field is a build identity, not a semver.
 *
 * @generated from message chalk.notebook.v1.KernelBuildInfo
 */
export type KernelBuildInfo = Message<"chalk.notebook.v1.KernelBuildInfo"> & {
  /**
   * chalk-private commit the chalk_nb_server binary was compiled from, stamped
   * at build time. Empty for a binary built outside CI (a local cargo build),
   * which is a meaningful answer rather than a missing one.
   *
   * @generated from field: string server_commit = 1;
   */
  serverCommit: string;

  /**
   * chalkdf distribution version in the kernel's venv, e.g. "3.39.5". Pinned in
   * the kernel image, so this identifies the wheel but not its contents.
   *
   * @generated from field: string chalkdf_version = 2;
   */
  chalkdfVersion: string;

  /**
   * libchalk's own build stamp, `0.0.1+<chalk-private commit>` (plus
   * `.dirty.<buildtype>` for an unclean build tree). This is the load-bearing
   * one: it names the exact commit the native extension was compiled from,
   * which the chalkdf version above only loosely implies.
   *
   * @generated from field: string libchalk_version = 3;
   */
  libchalkVersion: string;
};

/**
 * Describes the message chalk.notebook.v1.KernelBuildInfo.
 * Use `create(KernelBuildInfoSchema)` to create a new message.
 */
export const KernelBuildInfoSchema: GenMessage<KernelBuildInfo> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 16);

/**
 * @generated from message chalk.notebook.v1.ListInstalledPackagesRequest
 */
export type ListInstalledPackagesRequest = Message<"chalk.notebook.v1.ListInstalledPackagesRequest"> & {
};

/**
 * Describes the message chalk.notebook.v1.ListInstalledPackagesRequest.
 * Use `create(ListInstalledPackagesRequestSchema)` to create a new message.
 */
export const ListInstalledPackagesRequestSchema: GenMessage<ListInstalledPackagesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 17);

/**
 * @generated from message chalk.notebook.v1.ListInstalledPackagesResponse
 */
export type ListInstalledPackagesResponse = Message<"chalk.notebook.v1.ListInstalledPackagesResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.InstalledPackage packages = 1;
   */
  packages: InstalledPackage[];

  /**
   * Build identity of the kernel answering this call. Absent when the kernel
   * could not be asked; individual fields are independently empty-able, since a
   * kernel without chalkdf installed still has a server commit.
   *
   * @generated from field: chalk.notebook.v1.KernelBuildInfo build = 2;
   */
  build?: KernelBuildInfo;
};

/**
 * Describes the message chalk.notebook.v1.ListInstalledPackagesResponse.
 * Use `create(ListInstalledPackagesResponseSchema)` to create a new message.
 */
export const ListInstalledPackagesResponseSchema: GenMessage<ListInstalledPackagesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 18);

/**
 * One cell to analyze for its variable data-flow. The kernel does not execute
 * the source; it parses it with Python's `ast` module.
 *
 * @generated from message chalk.notebook.v1.NotebookCellSource
 */
export type NotebookCellSource = Message<"chalk.notebook.v1.NotebookCellSource"> & {
  /**
   * @generated from field: string cell_id = 1;
   */
  cellId: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * Template expressions belonging to this cell (markdown/text cells send
   * these with an empty `source`). Each expression's free names are unioned
   * into the report's `requires`; expressions never contribute `provides`
   * because eval() binds nothing.
   *
   * @generated from field: repeated chalk.notebook.v1.NotebookTemplateExpression template_expressions = 3;
   */
  templateExpressions: NotebookTemplateExpression[];

  /**
   * Explicit output binding for SQL/query/input cells, and for a code cell's
   * configured result variable. Unioned with bindings discovered in `source`.
   *
   * @generated from field: string result_variable_name = 4;
   */
  resultVariableName: string;

  /**
   * Explicit inputs for non-Python cell kinds (for example a table cell that
   * displays a dataframe variable). Unioned with reads discovered in source.
   *
   * @generated from field: repeated string required_variable_names = 5;
   */
  requiredVariableNames: string[];

  /**
   * Whether this cell can be scheduled. Inputs can provide names and table
   * cells can consume them, but neither runs on the kernel.
   *
   * @generated from field: bool runnable = 6;
   */
  runnable: boolean;
};

/**
 * Describes the message chalk.notebook.v1.NotebookCellSource.
 * Use `create(NotebookCellSourceSchema)` to create a new message.
 */
export const NotebookCellSourceSchema: GenMessage<NotebookCellSource> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 19);

/**
 * @generated from message chalk.notebook.v1.AnalyzeNotebookCellDependenciesRequest
 */
export type AnalyzeNotebookCellDependenciesRequest = Message<"chalk.notebook.v1.AnalyzeNotebookCellDependenciesRequest"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookCellSource cells = 1;
   */
  cells: NotebookCellSource[];
};

/**
 * Describes the message chalk.notebook.v1.AnalyzeNotebookCellDependenciesRequest.
 * Use `create(AnalyzeNotebookCellDependenciesRequestSchema)` to create a new message.
 */
export const AnalyzeNotebookCellDependenciesRequestSchema: GenMessage<AnalyzeNotebookCellDependenciesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 20);

/**
 * Per-cell analysis result. `provides` are the names the cell binds
 * (assignments, def/class, imports, for/with/walrus targets). `requires` are
 * the free names the cell reads that it does not bind locally. The kernel
 * reports raw per-cell reads/writes only; it does NOT assemble cross-cell
 * edges — the go-api-server does that with last-producer-wins ordering.
 *
 * @generated from message chalk.notebook.v1.CellDependencyReport
 */
export type CellDependencyReport = Message<"chalk.notebook.v1.CellDependencyReport"> & {
  /**
   * @generated from field: string cell_id = 1;
   */
  cellId: string;

  /**
   * @generated from field: repeated string provides = 2;
   */
  provides: string[];

  /**
   * @generated from field: repeated string requires = 3;
   */
  requires: string[];

  /**
   * Set when the cell source could not be parsed (e.g. a syntax error); the
   * report then carries empty provides/requires. Not an RPC-level error: one
   * unparseable cell must not fail analysis of the rest of the notebook.
   *
   * @generated from field: string parse_error = 4;
   */
  parseError: string;
};

/**
 * Describes the message chalk.notebook.v1.CellDependencyReport.
 * Use `create(CellDependencyReportSchema)` to create a new message.
 */
export const CellDependencyReportSchema: GenMessage<CellDependencyReport> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 21);

/**
 * @generated from message chalk.notebook.v1.AnalyzeNotebookCellDependenciesResponse
 */
export type AnalyzeNotebookCellDependenciesResponse = Message<"chalk.notebook.v1.AnalyzeNotebookCellDependenciesResponse"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.CellDependencyReport reports = 1;
   */
  reports: CellDependencyReport[];
};

/**
 * Describes the message chalk.notebook.v1.AnalyzeNotebookCellDependenciesResponse.
 * Use `create(AnalyzeNotebookCellDependenciesResponseSchema)` to create a new message.
 */
export const AnalyzeNotebookCellDependenciesResponseSchema: GenMessage<AnalyzeNotebookCellDependenciesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 22);

/**
 * Kernel-authoritative request for expanding a client's run intent into an
 * ordered set of runnable cells. All cells are sent in document order.
 *
 * @generated from message chalk.notebook.v1.PlanNotebookRunRequest
 */
export type PlanNotebookRunRequest = Message<"chalk.notebook.v1.PlanNotebookRunRequest"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookCellSource cells = 1;
   */
  cells: NotebookCellSource[];

  /**
   * @generated from field: repeated string requested_cell_ids = 2;
   */
  requestedCellIds: string[];

  /**
   * @generated from field: chalk.notebook.v1.NotebookRunScope run_scope = 3;
   */
  runScope: NotebookRunScope;
};

/**
 * Describes the message chalk.notebook.v1.PlanNotebookRunRequest.
 * Use `create(PlanNotebookRunRequestSchema)` to create a new message.
 */
export const PlanNotebookRunRequestSchema: GenMessage<PlanNotebookRunRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 23);

/**
 * @generated from message chalk.notebook.v1.PlanNotebookRunResponse
 */
export type PlanNotebookRunResponse = Message<"chalk.notebook.v1.PlanNotebookRunResponse"> & {
  /**
   * @generated from field: repeated string cell_ids = 1;
   */
  cellIds: string[];

  /**
   * The exact analysis used for this plan, useful for diagnostics and parity
   * checks without asking the kernel to parse the notebook a second time.
   *
   * @generated from field: repeated chalk.notebook.v1.CellDependencyReport reports = 2;
   */
  reports: CellDependencyReport[];
};

/**
 * Describes the message chalk.notebook.v1.PlanNotebookRunResponse.
 * Use `create(PlanNotebookRunResponseSchema)` to create a new message.
 */
export const PlanNotebookRunResponseSchema: GenMessage<PlanNotebookRunResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 24);

/**
 * @generated from message chalk.notebook.v1.NotebookBlobUploadHeader
 */
export type NotebookBlobUploadHeader = Message<"chalk.notebook.v1.NotebookBlobUploadHeader"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string value = 2;
   */
  value: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookBlobUploadHeader.
 * Use `create(NotebookBlobUploadHeaderSchema)` to create a new message.
 */
export const NotebookBlobUploadHeaderSchema: GenMessage<NotebookBlobUploadHeader> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 25);

/**
 * @generated from message chalk.notebook.v1.NotebookBlobUploadRequest
 */
export type NotebookBlobUploadRequest = Message<"chalk.notebook.v1.NotebookBlobUploadRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string artifact_kind = 2;
   */
  artifactKind: string;

  /**
   * @generated from field: string format = 3;
   */
  format: string;

  /**
   * @generated from field: string content_type = 4;
   */
  contentType: string;

  /**
   * @generated from field: optional int64 expected_byte_size = 5;
   */
  expectedByteSize?: bigint;

  /**
   * @generated from field: string expected_content_sha256 = 6;
   */
  expectedContentSha256: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookBlobUploadRequest.
 * Use `create(NotebookBlobUploadRequestSchema)` to create a new message.
 */
export const NotebookBlobUploadRequestSchema: GenMessage<NotebookBlobUploadRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 26);

/**
 * @generated from message chalk.notebook.v1.NotebookBlobUploadTarget
 */
export type NotebookBlobUploadTarget = Message<"chalk.notebook.v1.NotebookBlobUploadTarget"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string blob_id = 2;
   */
  blobId: string;

  /**
   * @generated from field: string upload_url = 3;
   */
  uploadUrl: string;

  /**
   * @generated from field: string method = 4;
   */
  method: string;

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookBlobUploadHeader headers = 5;
   */
  headers: NotebookBlobUploadHeader[];

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 6;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message chalk.notebook.v1.NotebookBlobUploadTarget.
 * Use `create(NotebookBlobUploadTargetSchema)` to create a new message.
 */
export const NotebookBlobUploadTargetSchema: GenMessage<NotebookBlobUploadTarget> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 27);

/**
 * @generated from message chalk.notebook.v1.NotebookBlobUploadComplete
 */
export type NotebookBlobUploadComplete = Message<"chalk.notebook.v1.NotebookBlobUploadComplete"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string blob_id = 2;
   */
  blobId: string;

  /**
   * @generated from field: int64 byte_size = 3;
   */
  byteSize: bigint;

  /**
   * @generated from field: string content_sha256 = 4;
   */
  contentSha256: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookBlobUploadComplete.
 * Use `create(NotebookBlobUploadCompleteSchema)` to create a new message.
 */
export const NotebookBlobUploadCompleteSchema: GenMessage<NotebookBlobUploadComplete> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 28);

/**
 * @generated from message chalk.notebook.v1.NotebookBlobUploadFailed
 */
export type NotebookBlobUploadFailed = Message<"chalk.notebook.v1.NotebookBlobUploadFailed"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string blob_id = 2;
   */
  blobId: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookBlobUploadFailed.
 * Use `create(NotebookBlobUploadFailedSchema)` to create a new message.
 */
export const NotebookBlobUploadFailedSchema: GenMessage<NotebookBlobUploadFailed> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 29);

/**
 * @generated from message chalk.notebook.v1.RunPythonCellRequest
 */
export type RunPythonCellRequest = Message<"chalk.notebook.v1.RunPythonCellRequest"> & {
  /**
   * @generated from oneof chalk.notebook.v1.RunPythonCellRequest.message
   */
  message: {
    /**
     * @generated from field: chalk.notebook.v1.RunPythonCellSpec spec = 1;
     */
    value: RunPythonCellSpec;
    case: "spec";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookBlobUploadTarget blob_upload_target = 2;
     */
    value: NotebookBlobUploadTarget;
    case: "blobUploadTarget";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.notebook.v1.RunPythonCellRequest.
 * Use `create(RunPythonCellRequestSchema)` to create a new message.
 */
export const RunPythonCellRequestSchema: GenMessage<RunPythonCellRequest> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 30);

/**
 * @generated from message chalk.notebook.v1.RunPythonCellResponse
 */
export type RunPythonCellResponse = Message<"chalk.notebook.v1.RunPythonCellResponse"> & {
  /**
   * @generated from oneof chalk.notebook.v1.RunPythonCellResponse.message
   */
  message: {
    /**
     * @generated from field: chalk.notebook.v1.NotebookRunEvent event = 1;
     */
    value: NotebookRunEvent;
    case: "event";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookBlobUploadRequest blob_upload_request = 2;
     */
    value: NotebookBlobUploadRequest;
    case: "blobUploadRequest";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookBlobUploadComplete blob_upload_complete = 3;
     */
    value: NotebookBlobUploadComplete;
    case: "blobUploadComplete";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookBlobUploadFailed blob_upload_failed = 4;
     */
    value: NotebookBlobUploadFailed;
    case: "blobUploadFailed";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.PythonExecutionTerminated terminated = 5;
     */
    value: PythonExecutionTerminated;
    case: "terminated";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.notebook.v1.RunPythonCellResponse.
 * Use `create(RunPythonCellResponseSchema)` to create a new message.
 */
export const RunPythonCellResponseSchema: GenMessage<RunPythonCellResponse> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_kernel_service, 31);

/**
 * @generated from enum chalk.notebook.v1.PythonExecutionOutcome
 */
export enum PythonExecutionOutcome {
  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_ERROR = 2;
   */
  ERROR = 2,

  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_TIMEOUT = 3;
   */
  TIMEOUT = 3,

  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_INTERRUPTED = 4;
   */
  INTERRUPTED = 4,

  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_KERNEL_DIED = 5;
   */
  KERNEL_DIED = 5,

  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_KERNEL_RESTARTED = 6;
   */
  KERNEL_RESTARTED = 6,

  /**
   * @generated from enum value: PYTHON_EXECUTION_OUTCOME_KERNEL_OOM_KILLED = 7;
   */
  KERNEL_OOM_KILLED = 7,
}

/**
 * Describes the enum chalk.notebook.v1.PythonExecutionOutcome.
 */
export const PythonExecutionOutcomeSchema: GenEnum<PythonExecutionOutcome> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_kernel_service, 0);

/**
 * @generated from enum chalk.notebook.v1.PythonInterruptOutcome
 */
export enum PythonInterruptOutcome {
  /**
   * @generated from enum value: PYTHON_INTERRUPT_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * interrupt_reply received from the kernel for the targeted execution.
   *
   * @generated from enum value: PYTHON_INTERRUPT_OUTCOME_INTERRUPTED = 1;
   */
  INTERRUPTED = 1,

  /**
   * The targeted (run_id, cell_run_id) is not the currently-executing cell;
   * nothing was interrupted.
   *
   * @generated from enum value: PYTHON_INTERRUPT_OUTCOME_NOT_CURRENTLY_EXECUTING = 2;
   */
  NOT_CURRENTLY_EXECUTING = 2,

  /**
   * The interrupt was sent but no interrupt_reply arrived in time.
   *
   * @generated from enum value: PYTHON_INTERRUPT_OUTCOME_KERNEL_UNRESPONSIVE = 3;
   */
  KERNEL_UNRESPONSIVE = 3,
}

/**
 * Describes the enum chalk.notebook.v1.PythonInterruptOutcome.
 */
export const PythonInterruptOutcomeSchema: GenEnum<PythonInterruptOutcome> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_kernel_service, 1);

/**
 * @generated from service chalk.notebook.v1.NotebookPythonKernelService
 */
export const NotebookPythonKernelService: GenService<{
  /**
   * Starts an execution independently of the lifetime of this unary request.
   * execution_id is the idempotency key: retrying the same execution and spec
   * returns the existing execution instead of enqueueing it twice.
   *
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.StartPythonCell
   */
  startPythonCell: {
    methodKind: "unary";
    input: typeof StartPythonCellRequestSchema;
    output: typeof StartPythonCellResponseSchema;
  },
  /**
   * Replays retained output after after_sequence, then tails new events until
   * termination. Clients reconnect with their last sequence after a transport
   * interruption; disconnecting this stream never cancels kernel execution.
   *
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.StreamPythonCellEvents
   */
  streamPythonCellEvents: {
    methodKind: "server_streaming";
    input: typeof StreamPythonCellEventsRequestSchema;
    output: typeof StreamPythonCellEventsResponseSchema;
  },
  /**
   * Responds to a kernel request emitted through StreamPythonCellEvents. The
   * execution and request IDs make delivery retryable and scope deduplication;
   * failures let the caller reject a request without waiting for a timeout.
   *
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.RespondToPythonCell
   */
  respondToPythonCell: {
    methodKind: "unary";
    input: typeof RespondToPythonCellRequestSchema;
    output: typeof RespondToPythonCellResponseSchema;
  },
  /**
   * Legacy connection-coupled execution API. Kept during migration while Go
   * callers move to StartPythonCell and StreamPythonCellEvents.
   *
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.RunPythonCell
   */
  runPythonCell: {
    methodKind: "bidi_streaming";
    input: typeof RunPythonCellRequestSchema;
    output: typeof RunPythonCellResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.InterruptPythonExecution
   */
  interruptPythonExecution: {
    methodKind: "unary";
    input: typeof InterruptPythonExecutionRequestSchema;
    output: typeof InterruptPythonExecutionResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.DescribeKernelSession
   */
  describeKernelSession: {
    methodKind: "unary";
    input: typeof DescribeKernelSessionRequestSchema;
    output: typeof DescribeKernelSessionResponseSchema;
  },
  /**
   * Lists the Python packages installed in the kernel's environment (the source
   * of truth for what is available to cells). Enumerated via importlib.metadata.
   *
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.ListInstalledPackages
   */
  listInstalledPackages: {
    methodKind: "unary";
    input: typeof ListInstalledPackagesRequestSchema;
    output: typeof ListInstalledPackagesResponseSchema;
  },
  /**
   * Analyzes each cell's source with Python's `ast` module and reports the
   * names it binds (provides) and the free names it reads (requires). This is
   * pure static analysis — no cell is executed — so the full dependency graph
   * is available without running the notebook. The kernel returns raw per-cell
   * reads/writes; cross-cell edge assembly happens server-side.
   *
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.AnalyzeNotebookCellDependencies
   */
  analyzeNotebookCellDependencies: {
    methodKind: "unary";
    input: typeof AnalyzeNotebookCellDependenciesRequestSchema;
    output: typeof AnalyzeNotebookCellDependenciesResponseSchema;
  },
  /**
   * @generated from rpc chalk.notebook.v1.NotebookPythonKernelService.PlanNotebookRun
   */
  planNotebookRun: {
    methodKind: "unary";
    input: typeof PlanNotebookRunRequestSchema;
    output: typeof PlanNotebookRunResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_notebook_v1_kernel_service, 0);

